import React from 'react'

import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import TimPenilaiPenilikPerencanaanPage from 'app/KinerjaTimPenilaiPenilikPage/pages/Perencanaan/Beranda'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import PageGuardTimPenilai from 'app/KinerjaTimPenilaiPenilikPage/components/PageGuardTimPenilai'

import type { PageProps } from 'app/KinerjaShared/components/KinerjaLayout'
import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const enabled = toggle?.['kinerja-penilik-tim-penilai-enabled'] || false

    if (!enabled) {
      return {
        redirect: {
          destination: '/404',
          permanent: false,
        },
      }
    }
  },
})

const Page = (_props: PageProps) => (
  <PageGuardTimPenilai type="PPK">
    <TimPenilaiPenilikPerencanaanPage />
  </PageGuardTimPenilai>
)

Page.Layout = KinerjaLayout

Page.layoutOpts = {
  hasHeader: true,
  pageTitle: 'Pengelolaan Kinerja',
}

export default Page
